import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPages.css';
import AdRotator from '../components/AdRotator';

const blogPosts = [
  {
    id: 'ai-vs-tarot',
    slug: 'ai-predictions-vs-tarot-which-is-more-accurate',
    title: 'AI Predictions vs Tarot: Which is More Accurate?',
    excerpt: 'Comparing data-driven AI forecasting with traditional tarot readings. Discover why statistical predictions outperform mystical methods.',
    date: '2025-10-15',
    readTime: '5 min read',
    image: '/blogi/ai-vs-tarot.jpg',
    category: 'Comparison'
  },
  {
    id: 'how-neural-networks-predict',
    slug: 'how-neural-networks-predict-life-events',
    title: 'How Neural Networks Predict Life Events',
    excerpt: 'Deep dive into the AI technology powering Mellodai. Learn how we train models on 25 years of real human data.',
    date: '2025-10-14',
    readTime: '7 min read',
    image: '/blogi/neural-networks.jpg',
    category: 'Technology'
  },
  {
    id: 'career-planning-ai',
    slug: '5-ways-ai-helps-career-planning',
    title: '5 Ways AI Can Help You Plan Your Career Path',
    excerpt: 'Practical applications of AI predictions for career transitions, promotions, and job changes.',
    date: '2025-11-13',
    readTime: '6 min read',
    image: '/blogi/career-planning.jpg',
    category: 'Career'
  },
  {
    id: 'Oracle-effect-predict-future',
    slug: 'Oracle-effect-predict-future',
    title: 'The Oracle Effect: Does Knowing the Future Guarantee a Better Life?',
    excerpt: 'Does Knowing the Future Makes you Richer, Happier, and Wiser.',
    date: '2025-11-25',
    readTime: '5 min read',
    image: '/blogi/techno_brain_headset.jpg',
    category: 'Technology'
  },
  {
    id: 'Constellations-to-Code',
    slug: 'Constellations-to-Code',
    title: 'From Constellations to Code: Why AI is the Future of Personal Forecasting',
    excerpt: 'Astrology never made any true predictions, nor assisted in telling the truth.',
    date: '2025-11-5',
    readTime: '9 min read',
    image: '/blogi/horoscope_echos.jpg',
    category: 'Comparison'
  }

];

const Blog = () => {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem('token');

  return (
    <div className="static-page">
      <header className="static-header">
        <nav className="static-nav">
          <span className="logo-icon">🔮</span>
          <div className="logo" onClick={() => navigate('/')}> Mellodai</div>
          <ul>
            <li><a href="/#features">Features</a></li>
            <li><a onClick={() => navigate('/how-it-works')}>How It Works</a></li>
            <li><a onClick={() => navigate('/philosophy')}>Philosophy</a></li>
            <li><a onClick={() => navigate('/method')}>The Method</a></li>
            <li><a onClick={() => navigate('/caregivers')}>For Caregivers</a></li>
            <li><a onClick={() => navigate('/blog')} className="active">Blog</a></li>
            <li><a onClick={() => navigate(isLoggedIn ? '/app' : '/login')} className="cta-button">{isLoggedIn ? 'Predictions' : 'Get Started'}</a></li>
          </ul>
        </nav>
      </header>
      <div className="headerAd">
    <AdRotator placement="sidebar" />
    {/*<AdRotator floating={true} placement="sidebar" />*/}
  </div>

      <section className="blog-hero">
        <h1>Mellodai Blog</h1>
        <p>Insights on AI predictions, life planning, and the future of forecasting</p>
      </section>

      <section className="blog-grid-section">
        <div className="blog-grid">
          {blogPosts.map(post => (
            <article key={post.id} className="blog-card" onClick={() => navigate(`/blog/${post.slug}`)}>
              <div className="blog-image">
                <img src={post.image} alt={post.title} />
                <span className="blog-category">{post.category}</span>
              </div>
              <div className="blog-content">
                <div className="blog-meta">
                  <span>{post.date}</span>
                  <span>🌟</span>
                  <span>{post.readTime}</span>
                </div>
                <h2>{post.title}</h2>
                <p>{post.excerpt}</p>
                <button className="read-more">Read More </button>
              </div>
            </article>
          ))}
        </div>
      </section>

      <footer className="static-footer">
        {/* Your existing footer */}
      </footer>
    </div>
  );
};

export default Blog;
